import { AbortControllerManager } from '../abortControllerManager';
import { authClient } from '../client';
import type {
  IEncounterTokenBody,
  IEncounterTokenResponse,
} from '@/types/encounterApi';

class EncounterApi extends AbortControllerManager {
  private readonly ENCOUNTER_URL = '/v2/encounter';

  constructor() {
    super();
  }

  getToken(body: IEncounterTokenBody): Promise<IEncounterTokenResponse> {
    const signal = this.createAbortController('getToken');
    return authClient.post(`${this.ENCOUNTER_URL}/token`, body, { signal });
  }
}

export const encounterApi = new EncounterApi();
